import {ContentsDetail} from './ContentsDetail'
import {User} from "./User";

export class Contents {

    constructor() {
        this.id = null
        this.user_id = null
        this.type = null
        this.title = null
        this.content = null
        this.category = null
        this.open_yn = null
        this.last_worker_id = null
        this.created_at = null
        this.updated_at = null
        this.deleted_at = null
        this.tags = []
        this.contentsDetail = new ContentsDetail()
        this.user = new User()
    }
}






